// @ts-nocheck
import {
  fetchTransactions,
  fetchContactPreferences,
  fetchEppOptions,
} from '../api';
import { call, put } from 'redux-saga/effects';
import {
  transactionFetched,
  transactionFetchFailed,
  recenttransactionFetched,
  transactionRequest,
  eppOptionsRequest,
  eppOptionsFetched,
  eppOptionsFetchFailed,
} from '../reducer/transactionsSlice';
import axiosInstance from '../api/axiosSetup';
import { API_URL } from '../api/apiMapper';

interface transactionRequestAction {
  type: typeof transactionRequest.type;
  payload: {
    accountId: string;
    customerId: string;
    recentTransaction?: boolean;
    limit?: number;
    cycleStartDate?: string;
    customerTypeId?: string;
    fromDate?: string;
    toDate?: string;
    merchantCategory?: string;
    offset?: number;
    allTransactions?: boolean;
    isRefresh?: boolean;
  };
}

interface eppOptionsRequestAction {
  type: typeof eppOptionsRequest.type;
  payload: {
    accountId: string;
    customerId: string;
    activityId: string;
  };
}

export function* fetchTransactionSaga(
  action: transactionRequestAction
): Generator<any, void, unknown> {
  const {
    accountId,
    customerId,
    recentTransaction = false,
    limit,
    cycleStartDate,
    customerTypeId,
    fromDate,
    toDate,
    merchantCategory,
    offset,
    allTransactions = false,
    isRefresh = false,
  } = action.payload;
  try {
    const response = yield call(
      fetchTransactions,
      'transactions',
      accountId,
      customerId,
      limit,
      cycleStartDate,
      customerTypeId,
      fromDate,
      toDate,
      merchantCategory,
      allTransactions,
      offset,
      isRefresh
    );
    yield put(transactionFetched(response));
    if (allTransactions) {
      yield put(recenttransactionFetched(response));
    }
  } catch (error) {
    console.log('Error transactions', error);
    yield put(transactionFetchFailed(error));
  }
}

export function* fetchEppOptionsSaga(
  action: eppOptionsRequestAction
): Generator<any, void, unknown> {
  const { accountId, customerId, activityId } = action.payload;
  try {
    const response = yield call(
      fetchEppOptions,
      'get_epp_options',
      accountId,
      customerId,
      activityId
    );

    // Check if response is an error object
    if (response && response.error) {
      yield put(eppOptionsFetchFailed(response.data));
    } else {
      yield put(eppOptionsFetched(response));
    }
  } catch (error) {
    console.log('Error fetching EPP options:', error);
    yield put(
      eppOptionsFetchFailed({
        message: 'Failed to fetch EPP options',
        details: error?.message || 'Unknown error',
      })
    );
  }
}
